import { graphql } from "@/lib/gql/__generated__";

export const RoomPriceRankUpdate_RoomPriceRankPage_Mutation = graphql(`
	mutation RoomPriceRankUpdate_RoomPriceRankPage($input: RoomPriceRankMastInput!) {
		roomPriceRankUpdate(input: $input) {
			userErrors
			priceRank {
				id
				hotelID
				ranks {
					priceRankID
					name
					color
					rooms {
						roomID
						roomName
						prices {
							adultNum
							price {
								currencyType
								amount
							}
						}
					}
					isStopSelling
				}
			}
		}
	}
`);
